import Link from "next/link";
import { usePathname } from "next/navigation";
import { useUIStore } from "@/store/ui/ui-store";
import { CiSettings } from "react-icons/ci";
import { MdOutlineDashboard } from "react-icons/md";

interface Props {
    icons: string;
    label: string;
    link?: string;
    collapsed?: boolean;
}

const ICONS: { [key: string]: JSX.Element } = {
    setting: <CiSettings />,
    dashboard: <MdOutlineDashboard />,
};

export const SubMenuLink = ({ icons, label, link = "/", collapsed = false }: Props) => {
    const path = usePathname();
    const closeMenu = useUIStore((state) => state.closeSideMenu);
    const active = path === link;

    return (
        <Link
            href={link}
            onClick={closeMenu}
            title={collapsed ? label : undefined}
            className={`group relative flex items-center rounded-lg text-xs transition-colors motion-reduce:transition-none
                ${collapsed ? "justify-center p-2.5" : "gap-2.5 p-2"}
                ${
                    active
                        ? "bg-[var(--nav-active-bg)] font-medium text-[var(--nav-active-fg)] before:absolute before:inset-y-1 before:left-0 before:w-0.5 before:rounded-full before:bg-[var(--nav-accent)]"
                        : "font-medium text-[var(--nav-fg-strong)] hover:bg-[var(--nav-hover-bg)]"
                }`}
        >
            <span className="shrink-0 text-[17px]">{ICONS[icons]}</span>
            {!collapsed && <span className="truncate">{label}</span>}
        </Link>
    );
};
